// This module exists because nothing downstream protects the phone-transfer number.
// Dashboard-API composes SipCallTo = agentAvailability.Phone verbatim from
// desired.phoneAvailability.phone (ParticipantManagementFunction.cs l. 298 et 389), with no
// normalization and no emptiness check; an unreadable number goes out in the INVITE, the
// exception is swallowed and logged as "treating as no answer" (l. 312-325), so the agent is
// never called and nothing signals it. This module is the last line of defence, North-American
// E.164 only, ruled by the owner. Widening to other country codes is an owner decision, outside
// this arc.

export const PHONE_NUMBER_EXAMPLE = '+1 514 555 0123'

/**
 * Keeps only the digits of `raw`; 10 digits, or 11 digits starting with `1`, become
 * '+1' + the last 10 digits. Anything else (other length, other country code, non-string)
 * returns null.
 */
export function normalizePhoneNumber(raw) {
  if (typeof raw !== 'string') {
    return null
  }
  const digits = raw.replace(/\D/g, '')
  if (digits.length === 10) {
    return `+1${digits}`
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1${digits.slice(1)}`
  }
  return null
}

export function isValidPhoneNumber(raw) {
  return normalizePhoneNumber(raw) !== null
}
